/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { ScreenTaskControllerTypes } from '../../core/navigation/ScreenTaskControllerTypes';
import { NetworkManager } from '../../core/network/NetworkManager';
import {
    onKeyOkNoNetworkOverlay,
    showNoNetworkOverlay,
} from '../overlay/nonetworkoverlay/nonetworkoverlay.reducers';

export const onKeyOkSplashScreen = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_SPLASH_SCREEN_TASKS:
            dispatch(onKeyOkSplashScreenOperation());
            break;

        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(onKeyOkNoNetworkOverlay());
            break;

        default:
            break;
    }
};

/**
 * Below reducers are related to operations on key events.
 */

const onKeyOkSplashScreenOperation = () => (dispatch: Function) => {
    if (NetworkManager.isNetworkDisconnected()) {
        dispatch(showNoNetworkOverlay());
    }
};
